<template lang="pug">
  DefaultLayout
    CommonSection(title="Сделка")
      PageSlug
        h1 Страница в разработке
</template>

<script>
import DefaultLayout from '@/layouts/Default.vue';
import CommonSection from '@/components/CommonSection.vue';
import PageSlug from '@/components/PageSlug.vue';

export default {
  name: 'DealsPage',
  components: { DefaultLayout, PageSlug, CommonSection },
};
</script>
